import React from 'react'
import { CSpinner } from '@coreui/react'

function FullLoader() {
  return (
    <div className="full-loader">
      <CSpinner color="success" />
    </div>
  )
}

export default FullLoader
